import { Container, Description, ImageWrapper } from 'components/bankItem/BankItem.style';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from '../tooltip/Tooltip';

interface IProps {
  paymentMethod: IMethod;
  handleClick: (id: string) => void;
  preSelected: boolean;
  isSelected: boolean;
  isDisabled: boolean;
  isMobileOrTablet?: boolean;
}

interface IState {
  tooltipRef: HTMLDivElement | null;
}

export default class BankItem extends PureComponent<IProps, IState> {
  private containerRef: React.RefObject<HTMLDivElement>;

  constructor(props) {
    super(props);
    this.containerRef = React.createRef();

    this.state = {
      tooltipRef: null,
    };
  }

  handleClick = () => {
    const {
      handleClick,
      paymentMethod: { id },
      preSelected,
      isDisabled,
    } = this.props;
    if (preSelected || isDisabled) return;
    handleClick(id);
  };

  render() {
    const {
      isSelected,
      isDisabled,
      preSelected,
      paymentMethod: { id, image, name, disableReason },
      isMobileOrTablet,
    } = this.props;

    const { tooltipRef } = this.state;

    const tooltipDataFor = `bank-item-${id}`;

    return (
      <>
        <Container
          ref={ref => {
            this.setState({ tooltipRef: ref });
          }}
          data-testid={tooltipDataFor}
          data-iscapture="true"
          data-tip
          data-for={tooltipDataFor}
          onClick={this.handleClick}
          isSelected={preSelected || isSelected}
          isDisabled={isDisabled}
          preSelected={preSelected}
          className={`bank-item__container ${preSelected ? 'bank-item__preselected' : ''}`}
          id={id}
        >
          <ImageWrapper className="image__wrapper" isSelected={isSelected} isDisabled={isDisabled}>
            {isDisabled ? <div className="disabled__mask" /> : ''}
            <img src={image} alt={name} />
          </ImageWrapper>

          <Description className="image__description">
            <FormattedMessage id={`bankItem.description.${id}`} />
          </Description>
        </Container>
        <Tooltip
          id={tooltipDataFor}
          parentRef={this.containerRef}
          showTooltip={isDisabled}
          isMobileOrTablet={isMobileOrTablet}
          messageId={disableReason ? `tooltip.method.disabled.${(disableReason as string).toLowerCase()}` : undefined}
          invokerRef={tooltipRef}
        />
      </>
    );
  }
}
